import { angularJsApp } from "../app";
import { IApiSubetapa } from "../services/api.model";

const transform = (items: IApiSubetapa[]) => (items || [])
  .filter((i) => i.value || (i.subnodes || []).some((s) => s.value))
  .map((i) => i.literal).join(', ');

angularJsApp.filter('valueFilter', () => {
  return (item: IApiSubetapa[]) => transform(item);
});